import { ThucDonAnh as IThucDonAnh } from '@/services/ThucDonAnh';
import { getThucDonAnh } from '@/services/ThucDonAnh/thucdonanh';
import { useState } from 'react';

export default () => {
  const [danhSach, setDanhSach] = useState<IThucDonAnh.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [record, setRecord] = useState<IThucDonAnh.Record>({} as any);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});
  const [filterInfo, setFilterInfo] = useState<any>({});
  const [edit, setEdit] = useState<boolean>(false);
  const [visibleForm, setVisibleForm] = useState<boolean>(false);
  const [dsLop, setDsLop] = useState(["Mầm non", "Nhà trẻ"]);

  const getThucDonAnhModel = async (donViId?: string) => {
    setLoading(true);
    const response = await getThucDonAnh({ page, limit, cond: {...cond, donViId} });
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total);
    setLoading(false);
  };
  return {
    danhSach,
    record,
    setRecord,
    loading,
    setLoading,
    getThucDonAnhModel,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    setVisibleForm,
    edit,
    setEdit,
    visibleForm,
    dsLop
  };
};
